import { render } from "./SecoundStep.vue?vue&type=template&id=1992f208"
import script from "./SecoundStep.vue?vue&type=script&lang=js"
export * from "./SecoundStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__